import { apiURL, responseFormat } from '@/service/base'
import { MembersClient } from '@circusmonkey/spock-protobuf/ts/frontend/member_grpc_web_pb.js'

const client = new MembersClient(apiURL, null, null)

/**
 * 檢查登入
 * @param func
 * @returns {Promise<unknown>}
 */
async function checkIsLogin(params = {}, func = null) {
	const req = new proto.base.Empty()

	const option = { 'grpc-session': localStorage.getItem('grpc-session') }
	const url = String(client.isLoggedin.toString().split('\n')[2]).replace(/\s+/g, '')
	const track = { req: req.toObject(), url }
	console.log('checkIsLogin grpc-session', option)
	return new Promise((resolve, reject) => {
		client.isLoggedin(req, option, (err, response) => {
			if (typeof func === 'function') resolve(func(err, response, track))
			else resolve(responseFormat(err, response, track))
		})
	}).then(resp => resp)
}

export {
	checkIsLogin
}
